// ----------------------------------------------------------------------------
// FEATURE FLAGS
// Toggle features on/off for development vs production builds.
// Flip the booleans here to enable/disable features across the app.
// ----------------------------------------------------------------------------

// True for local `vite` dev servers and the Azure dev deployment; false in prod.
// Deployed dev and prod BOTH build with `--mode production`, so MODE/DEV can't
// tell them apart — the dev pipeline sets VITE_ENVIRONMENT=development instead.
// Anything unrecognised (incl. unset) counts as production, so a missing var
// can never leak an in-development feature to prod.
const deployEnv = (import.meta.env.VITE_ENVIRONMENT as string | undefined)?.toLowerCase();
const isNonProdEnv =
  import.meta.env.DEV || deployEnv === 'development' || deployEnv === 'localhost';

export const featureFlags = {
  /**
   * Linked churches (Settings → "Create link code" for the Church Hub
   * handshake). Still in development: visible locally and on dev, hidden in prod.
   */
  churchHubLinking: isNonProdEnv,
  /** When true, shows the "Switch to Church Hub" button and port-to-church banner */
  churchHub: false,
  /**
   * Chord AI + audio separation (admin upload page). Always visible now that the
   * feature has launched; who can actually USE it is governed by the church's
   * SUBSCRIPTION TIER (Chord AI on Basic+, stems on Pro+), not the environment.
   * Non-entitled tiers still see the page and are prompted to upgrade (the
   * backend returns 402 on upload).
   */
  chordAi: true,
} as const;
